var map = {
	"./match_23_1.jpg": 599,
	"./match_23_10.jpg": 8519,
	"./match_23_2.jpg": 24,
	"./match_23_3.jpg": 2389,
	"./match_23_4.jpg": 7918,
	"./match_23_5.jpg": 2699,
	"./match_23_6.jpg": 6252,
	"./match_23_7.jpg": 1625,
	"./match_23_8.jpg": 2914,
	"./match_23_9.jpg": 7199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1267;